import * as React from 'react';
import colors from '../../utils/colors';
import Svg from './Svg';
import { Tooltip } from './Tooltip';
import './DefaultToolTip.scss';

export const DefaultTooltip = (props) => (
  <Tooltip {...props}>
    <Svg
      className='tooltip-default'
      data='/assets/info.svg'
      fill={colors.calicite}
    />
  </Tooltip>
);
